import { useNavigate } from 'react-router';
import { AlertCircleIcon, ArrowLeftIcon } from '@newcore/icons';
import { Button } from '@newcore/ui/buttons';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@newcore/ui/card';
import { cn } from '@newcore/ui/cn';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { Sizes } from '@newcore/ui/enums/sizes';
import { Text } from '@newcore/ui/typography';
import { textVariants } from '@newcore/ui/variants/typography-text-variants';
import { ROUTES } from '@/common/auth-routes';

export function AuthErrorPage() {
  const navigate = useNavigate();

  const handleBackToTenantSelection = () => {
    navigate(ROUTES.TENANT_SELECTION, { replace: true });
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-primary px-4'>
      <Card className='w-full max-w-lg'>
        <CardHeader className='space-y-1 text-center'>
          <div className='mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-error-solid/10'>
            <AlertCircleIcon className='h-6 w-6 text-error-primary' />
          </div>
          <CardTitle
            className={cn(
              textVariants({ weight: FontWeights.BOLD }),
              'text-error-primary'
            )}
          >
            Authentication Error
          </CardTitle>
          <CardDescription className='text-center'>
            We encountered an issue while trying to sign you in
          </CardDescription>
        </CardHeader>
        <CardContent className='space-y-6'>
          <div className='rounded-md border border-error/20 bg-error-solid/5 p-4'>
            <Text as='p' className='text-error-primary'>
              <Text as='strong' weight={FontWeights.SEMIBOLD}>
                Error:
              </Text>{' '}
              An authentication error occurred
            </Text>
          </div>

          <Button
            onClick={handleBackToTenantSelection}
            className='w-full'
            size={Sizes.XL}
            iconLeading={ArrowLeftIcon}
          >
            Back to tenant selection
          </Button>

          <div className='text-center'>
            <Text as='p' className='text-tertiary'>
              If you continue to experience issues, please contact your system
              administrator.
            </Text>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
